import ContactTeamForm from "@components/forms/ContactTeamForm"
import CloseIcon from "@components/icons/CloseIcon"
import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import "./PopupForms.scss"

const ContactTeamModal = ({
  show,
  handleClose,
  team,
  propertyDetails,
  officeDetails,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="popup-form-modal"
    >
      <Modal.Body className="popup-form-modal-body">
        <div className="popup-form-modal-content">
          <CloseIcon onClick={handleClose} color="secondary" />
          <div className="content-section">
            <h2>
              Contact <i>{team?.name}</i>
            </h2>
          </div>
          <ContactTeamForm
            team={team}
            propertyDetails={propertyDetails}
            officeDetails={officeDetails}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export const ContactTeamModalWithTrigger = ({
  buttonText,
  children,
  className,
  team,
  propertyDetails,
  officeDetails,
}) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  return (
    <>
      <button className={className || "details msg"} onClick={handleShow}>
        {children || buttonText ? (
          <>
            {children}
            {buttonText}
          </>
        ) : (
          <i className="icon icon-msg" />
        )}
      </button>
      <ContactTeamModal
        show={show}
        handleClose={handleClose}
        team={team}
        propertyDetails={propertyDetails}
        officeDetails={officeDetails}
      />
    </>
  )
}

export default ContactTeamModal
